
import moment from "moment";
import TextInput from "../../UIComponent/TextInput";
import ValidationText from "../../../utils/validation/ValidationText";
import DateInput from "../../inputs/DateInput";
import RadioButton from "../membershipTaskList/RadioButton";
import NumberInput from "../../UIComponent/NumberInput";

import MultiSelectDropdown from "../../dropdown/MultiSelectDropdown";
import SendClarifications from "../../../pages/membership/cPASApplication/SendClarifications";
import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
function CPASMembershipTaskListProcess(props) {
    const allowedStatuses = [ 4, 37, 38, 39, 40, 41, 21, 12 ];
    const isActionAllowed = props.statusId === 38;
    const isNotAllowedForAll = props.secretariatAndPreAssessmentStatusId === 32 || props.statusId === 1;
    const notallowedStatuses = [ 4, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 21, 12 ];

    const isPaymentPending = props.paymentStatus === "Pending";
    return (
        <div className="w-full organisation-basic-information">
            <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
                <div className="grid grid-cols-12 gap-6 w-full ">
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="text-xl text-[#000000] font-bold 2xl:mb-1">
                                    Application For Tier <span className="text-[#c00000]">*</span>
                                </h2>
                                <MultiSelectDropdown
                                    drpIdentity="Application_Tire"
                                    options={props.applicationTierList}
                                    // isMulti
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={props.handleChangeSelectorDropdown}
                                    allowSelectAll={false}
                                    value={props.applicationTierList.filter(
                                        (appTier) =>
                                            appTier.value ===
                                            props.basicApplicationDetails.applicationTierId
                                    )}
                                    disabled={true}
                                    className="black-border-disabled-select"
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-12 mb-3">
                    <div className="col-span-12">
                        <div className="form-info-title">
                            <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                                Basic Details
                            </h4>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-3 mb-3">
                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                        <h2 className="input-title mb-3">
                            First Name
                            <span className="text-[#C00000]"> *</span>
                        </h2>
                        <div className="dropdown business-tel-no">
                            {/* Row: Dropdown + Textbox */}
                            <div className="inputname flex items-center left-border-none">
                                <div className="textbox-one w-[130px] name-dropdown-position">
                                    <MultiSelectDropdown
                                        drpIdentity="MrMrsId"
                                        options={props.mrMrsList}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={props.handleChangeSelectorDropdown}
                                        allowSelectAll={false}
                                        value={props.mrMrsList.filter(
                                            (role) =>
                                                role.value === props.basicApplicationDetails.mrMrsId
                                        )}
                                        disabled={true}
                                        className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
                                    />
                                </div>
                                <TextInput
                                    name="firstName"
                                    value={props.basicApplicationDetails.firstName}
                                    identity="Caps_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "BasicApplication")
                                    }
                                    onBlur={() =>
                                        props.validateField("firstName", "Basic_Application")
                                    }
                                    disabled={true}
                                    className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
                                />

                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                        <h2 className="input-title mb-3">
                            Last Name
                            <span className="text-[#C00000]"> *</span>
                        </h2>

                        <div className="dropdown">
                            <TextInput
                                placeholder=""
                                name="lastName"
                                value={props.basicApplicationDetails.lastName}
                                identity="Caps_Application"
                                handleChange={(e) =>
                                    props.handleChange(e, "BasicApplication")
                                }
                                onBlur={() =>
                                    props.validateField("lastName", "Basic_Application")
                                }
                                disabled={true}
                                className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
                            />

                        </div>
                    </div>




                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                        <h2 className="input-title mb-3">
                            Contact Number
                            <span className="text-[#C00000]"> *</span>
                        </h2>
                        <div className="dropdown">
                            <NumberInput
                                placeholder=""
                                name="contactNumber"
                                value={props.basicApplicationDetails.contactNumber}
                                identity="Caps_Application"
                                handleChange={(e) =>
                                    props.handleChange(e, "BasicApplication")
                                }
                                onBlur={() =>
                                    props.validateField("contactNumber", "Basic_Application")
                                }
                                disabled={true}
                                className="border-black"
                            />
                        </div>
                    </div>

                    <div className="lg:col-span-6 col-span-12 input-sec-texts">
                        <h2 className="input-title mb-3">
                            Email Address
                            <span className="text-[#C00000]"> *</span>
                        </h2>
                        <div className="dropdown">
                            <TextInput
                                name="emailAddress"
                                value={props.basicApplicationDetails.emailAddress}
                                identity="Caps_Application"
                                handleChange={(e) =>
                                    props.handleChange(e, "BasicApplication")
                                }
                                onBlur={() =>
                                    props.validateField("emailAddress", "Basic_Application")
                                }
                                disabled={true}
                                className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
                            />

                        </div>
                    </div>
                    {!notallowedStatuses.includes(props.statusId) && (
                        <div className="lg:col-span-12 col-span-12 input-sec-texts Secretariat-sec cpas-common-card">

                            <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-12">
                                <div className="col-span-12">
                                    <div className="form-info-title">
                                        <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                                            Secretariat Review
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="secretariat-btn-sec body-common-sec">

                                <button
                                    className="btn btn-reject"
                                    disabled={isNotAllowedForAll}
                                    // onClick={() => props.updateSecretariatAndPreAssessmentStatus(32)}
                                    onClick={() => props.rejectSecretariatReview()}
                                >
                                    Reject
                                </button>

                                <button
                                    className="btn btn-send"
                                    disabled={isNotAllowedForAll}
                                    onClick={() => {
                                        props.setSendClarificationsFlag(true);    // Secretariat
                                        // props.updateSecretariatAndPreAssessmentStatus(29);
                                    }}
                                >
                                    Send clarification
                                </button>
                                <button
                                    className="btn btn-sen-pre-assessment"
                                    disabled={isPaymentPending || isNotAllowedForAll}
                                    // onClick={() => props.updateSecretariatAndPreAssessmentStatus(31)}
                                    onClick={() => props.sendForPreAssessmentSecretariatReview()}
                                >
                                    Send for Pre-Assessment
                                </button>

                            </div>
                        </div>
                    )}
                    <div className="lg:col-span-12 col-span-12 input-sec-texts Pre-Assessment-sec cpas-common-card">
                        {(props.statusId === 31 || props.statusId === 33) && (
                            <>
                                <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-12">
                                    <div className="col-span-12">
                                        <div className="form-info-title">
                                            <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                                                Pre-Assessment
                                            </h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="Pre-Assessment-btn-sec body-common-sec">
                                    <button
                                        className="btn btn-reject"
                                        disabled={isPaymentPending || isNotAllowedForAll}
                                        onClick={() => props.rejectSPreAssessmentStage()}
                                    >
                                        Reject
                                    </button>

                                    <button
                                        className="btn btn-send"
                                        disabled={isPaymentPending || isNotAllowedForAll}
                                        onClick={() => {
                                            props.setSendClarificationsFlag(false);   // Pre-assessment
                                            //props.updateSecretariatAndPreAssessmentStatus(33);
                                        }}
                                    >
                                        Send clarification
                                    </button>
                                    <button
                                        className="btn btn-sen-pre-assessment"
                                        disabled={isPaymentPending || isNotAllowedForAll}
                                        onClick={() => {
                                            props.updateSecretariatAndPreAssessmentStatus(31);
                                            props.openScoringSheet();
                                        }}
                                    >
                                        Upload Score Sheet
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                    {allowedStatuses.includes(props.statusId) && (
                        <div className="lg:col-span-12 col-span-12 cpas-common-card interview-sec">
                            <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-12">
                                <div className="col-span-12">
                                    <div className="form-info-title">
                                        <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                                            Interview
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <div className="secretariat-btn-sec body-common-sec">
                                <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between">

                                    {/* Dynamic Assessors */}
                                    {props.allInterviewDetailsList?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="col-span-12 grid grid-cols-12 md:gap-4 gap-3"
                                        >
                                            {/* Name Section */}
                                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                                <h2 className="input-title mb-3">
                                                    {index === 0 ? "Lead Assessor" : `Assessor ${index}`}
                                                </h2>

                                                <TextInput
                                                    placeholder="Candidate Name"
                                                    value={item?.assessorName || ""}
                                                    disabled={true}
                                                    className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
                                                />
                                            </div>

                                            {/* Button Section */}
                                            {item.assessorInterviewSheetPath && (
                                                <div className="lg:col-span-6 col-span-12 btn-center">
                                                    <button
                                                        className="btn btn-send"
                                                        onClick={() =>
                                                            props.GetCPASMemberFiles(
                                                                "Upload_Interview_Sheet",
                                                                item.assessorInterviewSheetPath
                                                            )
                                                        }
                                                    >
                                                        Download Interview Result
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}

                                    {/* Comments */}
                                    <div className="lg:col-span-12 col-span-12">
                                        <h2 className="input-title mb-3">
                                            Comments <span className="text-[#c00000]">*</span>
                                        </h2>

                                        <textarea
                                            //className="w-full"
                                            rows="4"
                                            name="interviewComments"
                                            value={props.interviewComment}
                                            onChange={(e) => props.handleChange(e, "interviewComment")}
                                            disabled={!isActionAllowed}
                                            className={`w-full ${!isActionAllowed
                                                ? "bg-gray-100 text-gray-500 border-black cursor-not-allowed"
                                                : ""
                                                }`}

                                        />
                                        <div className='mt-5 file-uploaded-txt flex items-center'>
                                            <span className='text-[#ff0000]'>
                                                {props.interviewText}
                                            </span>
                                        </div>
                                    </div>


                                    {/* Buttons */}
                                    <div className="lg:col-span-12 col-span-12">
                                        <div className="bottom-btn-sec">
                                            {props.isRejectLoading ? (
                                                <ButtonLoader />
                                            ) : (
                                                <button
                                                    className="btn btn-reject"
                                                    disabled={!isActionAllowed}
                                                    onClick={() => {
                                                        props.RejectCpasMember();
                                                    }}
                                                >
                                                    Reject
                                                </button>
                                            )}
                                            {props.isApproveLoading ? (
                                                <ButtonLoader />
                                            ) : (

                                                <button
                                                    className="btn btn-approve"
                                                    disabled={!isActionAllowed}
                                                    onClick={() => {
                                                        props.AcceptAndApproveCpasMember(true);
                                                    }}

                                                >
                                                    Approve
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    )}

                    {(props.statusId === 40 || props.statusId === 41) && (
                        <div className="lg:col-span-12 col-span-12 cpas-common-card interview-sec">
                            <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-12">
                                <div className="col-span-12">
                                    <div className="form-info-title">
                                        <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                                            Appeal
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="secretariat-btn-sec body-common-sec">
                                <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between">
                                    <div className="lg:col-span-12 col-span-12">
                                        <h2 className="input-title mb-3">Reason for Appeal</h2>
                                        {/* <textarea
                                            className="w-full"
                                            id="comments"
                                            rows="4"
                                            name="comments"
                                        /> */}
                                        <textarea
                                            // className="w-full"
                                            rows="4"
                                            name="appealComment"
                                            value={props.basicApplicationDetails.appealComment}
                                            disabled={true}
                                            className="w-full black-border-disabled-select"
                                        // onChange={(e) => props.handleChange(e, "interviewComment")}
                                        />

                                    </div>
                                    <div className="lg:col-span-12 col-span-12">
                                        <div className="bottom-btn-sec">
                                            {props.isRejectappealLoading ? (
                                                <ButtonLoader />
                                            ) : (
                                                <button
                                                    className="btn btn-reject"
                                                    disabled={props.statusId === 41 || props.basicApplicationDetails.paymentStatusForAppeal === "Pending"}
                                                    onClick={() => {
                                                        props.RejectAppealCpasMember(true);
                                                    }}
                                                >
                                                    Reject
                                                </button>
                                            )}


                                            {props.isAppealLoading ? (
                                                <ButtonLoader />
                                            ) : (
                                                <button
                                                    className="btn btn-approve"
                                                    disabled={props.statusId === 41 || props.basicApplicationDetails.paymentStatusForAppeal === "Pending"}
                                                    onClick={() => {
                                                        props.AcceptAndApproveCpasMember(false);
                                                    }}
                                                >
                                                    Approve
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="membership-task-list-process-sec">
                    <div className="send-clarification-model">
                        <SendClarifications
                            clarification={props.clarification}
                            clarificationModal={props.clarificationModal}
                            isLoading={props.isLoading}
                            setOpenModal={props.setOpenModal}
                            // Change this line to match the prop name assigned in Parent
                            onTinyEceEditorChange={props.onTinyEceEditorChange}
                            saveClarificationDetails={props.saveClarificationDetails}
                        />

                    </div>
                </div>
            </div>

        </div>


    );
}
export default CPASMembershipTaskListProcess;
